import {Grid} from '@material-ui/core';
import {useLocation, useParams, useSearchParams} from 'react-router-dom';

import {LeftPanelContent} from './components/LeftPanelContent';
import {logoutAnonymousSession} from '../../../culture-agent-results';
import {InvalidTalentSurveyMessage} from '../../../features/applicant/registration/components/InvalidTalentSurveyMessage';
import SignupForm from '../../../features/applicant/registration/components/SignUpForm/SignupForm';
import {useTalentSurveyPage} from '../../talent/survey/useTalentSurveyPage';

export default function SignUpPage() {
  const urlParams = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const talentSurveyId = urlParams.talent_survey_id ?? '';
  const isChatSurvey = searchParams.get('flow') === 'chat';
  const chatGetResultsPayload = (
    location.state as {
      chatGetResultsPayload?: Record<string, unknown>;
    }
  )?.chatGetResultsPayload;

  const {
    data: talentSurveyWithApplicantId,
    loading,
    error,
  } = useTalentSurveyPage(talentSurveyId, {
    flow: isChatSurvey ? 'chat' : 'classic',
    chatGetResultsPayload: isChatSurvey ? chatGetResultsPayload : undefined,
  });

  if (!loading && error) {
    return <InvalidTalentSurveyMessage surveyId={talentSurveyId} />;
  }

  if (loading || !talentSurveyWithApplicantId) {
    return <></>;
  }

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          md={6}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={{xs: 'center', md: 'left'}}
          gap={3}
        >
          <LeftPanelContent
            titleTranslationKey={'registration.signUp.page.title'}
            subtitleTranslationKey={'registration.signUp.page.subtitle'}
          />
        </Grid>
        <Grid item xs={12} md={6} display={'flex'} justifyContent={{xs: 'center', md: 'right'}} padding={{xs: 0}}>
          <SignupForm
            talentSurveyId={talentSurveyWithApplicantId.id}
            onSignUpSuccess={isChatSurvey || chatGetResultsPayload ? logoutAnonymousSession : undefined}
          />
        </Grid>
      </Grid>
    </>
  );
}
